import actionTypes from '../actions/actionTypes';

const defaultState = { useEmailPrompt: true };

export default (state = defaultState, { type, payload }) => {
  switch (type) {
    case actionTypes.SET_EMAIL_PREFERENCES:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
